import moment from 'moment'

export const ATTACHMENT_TYPE = { LYRICS: 0, PDF: 1, DOCX: 2, SCRIPT: 3 }

/**
 * 
 * @param {*} media 
 * @returns 
 */
export const getAttachmentLabel = (media) => {
    if (media.attachments && media.attachments.length) {
        switch (media.attachments[0].attachmentType) {
            default:
                return 'Attachment'
            case ATTACHMENT_TYPE.LYRICS:
                return 'Lyrics'
            case ATTACHMENT_TYPE.SCRIPT:
                return 'Script'
            case ATTACHMENT_TYPE.PDF:
                return 'PDF'
            case ATTACHMENT_TYPE.DOCX:
                return 'Word docx'
        }
    }
    return 'No attachments'
}

export const createLyrics = (attachmentContent) => {
    return { attachmentType: ATTACHMENT_TYPE.LYRICS, attachmentContent }
}

export const createScript = (attachmentContent) => {
    return { attachmentType: ATTACHMENT_TYPE.SCRIPT, attachmentContent }
}

export const createPdf = (attachmentContent) => {
    return { attachmentType: ATTACHMENT_TYPE.PDF, attachmentContent }
}

export const getCopyright = (song) => {
    const { firstName, lastName, createdAt } = song
    return `Copyright ${moment(createdAt).format('YYYY')} ${firstName} ${lastName}`
}

/**
 * 
 * @param {*} song 
 * @returns True if there is an attachment with ATTACHMENT_TYPE.LYRICS or ATTACHMENT_TYPE.SCRIPT
 */
export const hasLyricsOrScript = (song) => {
    let good
    const { attachments } = song
    if (attachments) {
        const ix = attachments.findIndex(at =>
            at.attachmentType === ATTACHMENT_TYPE.LYRICS
            ||
            at.attachmentType === ATTACHMENT_TYPE.SCRIPT
        )
        good = ix !== -1
    }
    return good
}